import React, { useEffect, useRef } from "react";
import { SubTitle } from "@components/atoms/sub-title/sub-title";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";

import CloseIcon from "@src/assets/svg/close-icon.svg";
import Modal from "../Modal";
import { Button } from "@components/atoms/buttons/button/button";

import styles from "./filter-modal.module.scss";
import { FilterModalObj } from "./filter-modal-obj";
import { useNewInitialFilterModalHook } from "./use-new-initial-filter-modal-hook";

const cssClassName = "filter-modal";
interface FilterModalProps {
  useHook?: () => FilterModalObj;
}

const Head = ({ handlecloseModal, texts }: Partial<FilterModalObj>) => {
  return (
    <div className={styles[`${cssClassName}__upper-wrapper`]}>
      <SubTitle text={texts.filterSubtitle} />
      <IconButton fun={handlecloseModal} icon={CloseIcon} />
    </div>
  );
};

const Input = ({
  setLocalFilterInputContent,
  localFilterInputContent,
  texts,
  ...props
}: Partial<FilterModalObj>) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  return (
    <label
      style={{
        fontSize: 12,
      }}
    >
      {texts.labelText}
      <textarea
        ref={textareaRef}
        placeholder={texts.textAreaPlaceholder}
        value={localFilterInputContent}
        onChange={(e) => {
          setLocalFilterInputContent(e.target.value);
        }}
        className={styles[`${cssClassName}__textarea`]}
        {...props}
      />
    </label>
  );
};

// eslint-disable-next-line react/display-name
const Buttons = ({
  handleShowResultsClick,
  handleClearFilterClick,
  localFilterInputContent,
  texts,
  minFilterInputLength,
}: Partial<FilterModalObj>) => {
  return (
    <div className={styles[`${cssClassName}__button-wrapper`]}>
      <Button
        variant={[
          "full-width",
          "big",
          `${
            localFilterInputContent.length < minFilterInputLength
              ? "inactive"
              : ""
          }`,
        ]}
        text={texts.showResults}
        fun={handleShowResultsClick}
        disabled={localFilterInputContent.length < minFilterInputLength}
      />
      <Button
        variant={["secondary", "full-width"]}
        text={texts.clearFilter}
        fun={handleClearFilterClick}
      />
    </div>
  );
};

export const FilterModal = ({
  useHook = useNewInitialFilterModalHook,
}: FilterModalProps) => {
  const {
    handlecloseModal,
    handleShowResultsClick,
    handleClearFilterClick,
    setLocalFilterInputContent,
    localFilterInputContent,
    texts,
  } = useHook();

  const minFilterInputLength = 3;

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (localFilterInputContent?.length >= minFilterInputLength) {
        handleShowResultsClick();
      }
    }
  };

  return (
    <Modal>
      <div className={styles[cssClassName]}>
        <Head handlecloseModal={handlecloseModal} texts={texts} />
        <Input
          setLocalFilterInputContent={setLocalFilterInputContent}
          localFilterInputContent={localFilterInputContent}
          texts={texts}
          onKeyDown={handleInputKeyDown}
        />
        <Buttons
          handleShowResultsClick={handleShowResultsClick}
          handleClearFilterClick={handleClearFilterClick}
          localFilterInputContent={localFilterInputContent}
          texts={texts}
          minFilterInputLength={minFilterInputLength}
        />
      </div>
    </Modal>
  );
};
